import { createApiInstance } from './config'

// 使用统一的API实例
const api = createApiInstance()

// 用户管理API
export const userAPI = {
  // 获取用户列表（支持分页、搜索、角色筛选、状态筛选、游戏筛选、上级代理筛选和排序）
  getUserList(page = null, pageSize = null, keyword = null, role = null, isDeleted = null, game = null, parentId = null, sortParam = null) {
    const params = {}
    if (page !== null && pageSize !== null) {
      params.page = page
      params.pageSize = pageSize
    }
    if (keyword !== null && keyword.trim() !== '') {
      params.keyword = keyword.trim()
    }
    if (role !== null) {
      params.role = role
    }
    if (isDeleted !== null) {
      params.isDeleted = isDeleted
    }
    if (game !== null && game.trim() !== '') {
      params.game = game.trim()
    }
    if (parentId !== null) {
      params.parentId = parentId
    }
    if (sortParam !== null && sortParam.sortField && sortParam.sortOrder) {
      params.sortField = sortParam.sortField
      params.sortOrder = sortParam.sortOrder
    }
    return api.get('/users', { params })
  },

  // 创建用户
  createUser(userData) {
    return api.post('/users', userData)
  },

  // 获取单个用户信息
  getUser(userId) {
    return api.get(`/users/${userId}`)
  },

  // 更新用户信息
  updateUser(userId, userData) {
    return api.put(`/users/${userId}`, userData)
  },

  // 设置用户过期
  deleteUser(userId) {
    return api.delete(`/users/${userId}`)
  },

  // 标记用户为删除状态
  markUserAsDeleted(userId) {
    return api.post(`/users/${userId}/mark-deleted`)
  },

  // 编辑用户（新的编辑接口）
  editUser(userId, editData) {
    return api.post(`/users/${userId}/edit`, editData)
  },

  // 重置用户密码
  resetUserPassword(userId, newPassword) {
    return api.post(`/users/${userId}/reset-password`, {
      new_password: newPassword
    })
  },

  // 获取代理列表（仅管理员可用）
  getAgentList() {
    return api.get('/users/agents')
  },

  // 查询用户操作日志（管理员和代理可用）
  getOperationLogs(page = 1, pageSize = 20, operationType = null, operatorUsername = null, targetUsername = null) {
    const params = {
      page,
      pageSize
    }
    if (operationType) {
      params.operationType = operationType
    }
    if (operatorUsername) {
      params.operatorUsername = operatorUsername
    }
    if (targetUsername) {
      params.targetUsername = targetUsername
    }
    return api.get('/users/operation-logs', { params })
  }
}

export default userAPI